export default __webpack_public_path__ + "static/media/lumisight-full.7004b105.png";